export function fuzzyScore(query, candidate) {
  if (!query) return 1
  const q = query.toLowerCase()
  const c = candidate.toLowerCase()
  if (c.startsWith(q)) return 1000 - c.length
  const wordStart = c.search(new RegExp(`\\b${escapeRegExp(q)}`))
  if (wordStart >= 0) return 500 - wordStart
  let qi = 0
  let score = 0
  let streak = 0
  for (let ci = 0; ci < c.length && qi < q.length; ci++) {
    if (c[ci] === q[qi]) {
      qi++
      streak++
      score += streak * 2
    } else {
      streak = 0
    }
  }
  return qi === q.length ? score : -1
}

export function fuzzyFilter(query, items, key = (item) => item) {
  return items
    .map((item) => ({ item, score: fuzzyScore(query, key(item)) }))
    .filter(({ score }) => score >= 0)
    .sort((a, b) => b.score - a.score)
    .map(({ item }) => item)
}

function escapeRegExp(text) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}
